import { isBVisitC } from '@src/js/common/utils';

export const canSaveMyTemplate = (): boolean => {
    // B访问C，不允许另存为模版
    if (isBVisitC()) return false;
    return !!window.clientVars?.privilegeAttribute?.can_save_template;
};

export default canSaveMyTemplate;
